import { FileDownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";
import { useLazyListVendorShipmentPricesForReportsQuery } from "store/services/reportApi";
import { exportExcelFile } from "utils/exportExcelFile";

const ExportVendorTransaction = () => {
  const [fetchVendorTransaction, { isLoading, isFetching }] =
    useLazyListVendorShipmentPricesForReportsQuery();

  const handleDownload = async (data) => {
    try {
      const responseData = await fetchVendorTransaction({}).unwrap();

      console.log("Response Data:", responseData);

      if (!responseData?.data || responseData.data.length === 0) {
        toast.info("No data.");
        return;
      }

      const formattedData = responseData?.data.map((row, index) => ({
        SN: index + 1,
        Name: row.vendorName || "N/A",
        "Pending COD": row?.codAmount || 0,
        "Pending Charge": row?.chargeAmount || 0,
        Paid: row?.totalPaid || 0,
        Collected: row?.totalCollected || 0,
        Total: row?.total || 0,
      }));

      exportExcelFile({
        sheetData: formattedData,
        fileName: "Vendor_Transaction_Report",
      });
      toast.success("Data downloaded successfully");
    } catch (error) {
      toast.error(
        "Error fetching Vendor transaction report data: " + error.message
      );
    }
  };

  return (
    <div>
      <Tooltip title="Export Excel" arrow>
        <IconButton
          color="success"
          onClick={handleDownload}
          disabled={isLoading || isFetching}
        >
          <FileDownloadOutlined />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default ExportVendorTransaction;
